/* global rp$, window */
import './store_logo.scss';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Store Logo Module
	 * -----------------------------------------
	 * @section store_logo_js
	 ********************************************/
	(function StoreLogoModule() {
		$onReady({rp$, window,
			label: 'store_logo',
			fn: function () {
				rp$('.image-logo').each(function() {
					rp$(this).attr('src', rp$(this).attr('lazySrc')).show();
				});
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
